<!--
 * @Author: maogangfeng
 * @Date: 2020-03-12 16:25:36
 * @Desc: 图表表头
 -->
<template>
  <div>
    <div class="panel-title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  name: 'PanelTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    width: {
      type: [String, Number],
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.panel-title {
  display: inline-block;
  opacity: 0.9;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  line-height: 30px;
  color: #ffffff;
  letter-spacing: 0;
  margin-bottom: 62px;
  background: url('~@/assets/images/OperationSpecialist/trend_count_bg.png') no-repeat;
  background-size: 100% 100%;
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .panel-title {
    height: 60px;
    line-height: 36px;
    padding: 12px 22px 12px 18px;
    margin-bottom: 62px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .panel-title {
    height: 48px;
    line-height: 29px;
    font-size: 16px;
    padding: 9px 18px 12px;
    margin-bottom: 83px;
  }
}

@media screen and (max-width: 1599px) {
  .panel-title {
    height: 38px;
    line-height: 24px;
    font-size: 12px;
    padding: 7px 18px 8px;
  }
}
</style>
